/**
 * MicrosoftButton - Social login button for Microsoft/Azure Entra ID
 * Part of PROJ-025: Azure CIAM Authentication
 *
 * Uses popup-based OAuth for better UX - user stays on the app while authenticating
 */

import { Button } from '@/components/ui/button'
import { useOAuthPopup } from '@/hooks/useOAuthPopup'

interface MicrosoftButtonProps {
  onClick?: () => void
  disabled?: boolean
  className?: string
  /** Use redirect instead of popup (fallback) */
  useRedirect?: boolean
}

// Microsoft logo SVG
function MicrosoftLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 23"
      aria-hidden="true"
    >
      <path fill="#f35325" d="M1 1h10v10H1z" />
      <path fill="#81bc06" d="M12 1h10v10H12z" />
      <path fill="#05a6f0" d="M1 12h10v10H1z" />
      <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
  )
}

export function MicrosoftButton({
  onClick,
  disabled = false,
  className,
  useRedirect = false,
}: MicrosoftButtonProps) {
  const { openPopup } = useOAuthPopup()

  const handleClick = () => {
    if (onClick) {
      onClick()
      return
    }

    const authUrl = '/api/v1/auth/azure/login'

    if (useRedirect) {
      // Fallback: full page redirect
      window.location.href = authUrl
    } else {
      // Default: popup-based OAuth
      openPopup(authUrl, 'azure')
    }
  }

  return (
    <Button
      type="button"
      variant="outline"
      className={`h-11 w-full gap-3 ${className ?? ''}`}
      onClick={handleClick}
      disabled={disabled}
    >
      <MicrosoftLogo className="h-5 w-5" />
      <span>Continuar con Microsoft</span>
    </Button>
  )
}

export default MicrosoftButton
